import React from 'react';
import PropTypes from 'prop-types';
import BarsCompare from 'components/common/charts/BarsCompare';
function SectorsComparison(props) {
  const { info, data } = props;
  const sectors = {
    mining: 'MINING',
    'oil-gas': 'OIL & GAS',
    'oil & gas': 'OIL & GAS'
  };
  const getComparisonGraph = (classes) => (<div className={`compare-charts ${classes}`}>
    <h2 className="subtitle">{info.country}: oil & gas vs. mining scores</h2>
    <div className="charts-items">
      {data.map((chart, i) => (
        <BarsCompare
          isComposite={i === 0}
          title={[sectors[info.sectors[1]], sectors[info.sectors[0]]]}
          key={i}
          id={`compare${i}`}
          data={chart}
        />
      ))}
    </div>
  </div>);
  const getLargerWidthScreen = () => <article className="c-sectors-comparition">
    <div className="row compare-intro">
      <div className="column small-12 medium-small-11 medium-10 medium-offset-1">
        <h1 className="-light">Governance performance across oil, gas and mining sectors</h1>
        <h2 className="subtitle" dangerouslySetInnerHTML={{ __html: info.title }}></h2>
      </div>
    </div>

    <div className="compare-graphs medium-offset-1">
      {getComparisonGraph('compare-chart-wrapper-floated')}
      <div>
        <p dangerouslySetInnerHTML={{ __html: info.description }}></p>
      </div>

    </div>
  </article>;
  const getSmallerWidthScreen = () => <article className="c-sectors-comparition">
    <div className="row compare-intro">
      <div className="column small-12 medium-small-11 medium-10 medium-offset-1">
        <h1 className="-light">Governance performance across oil, gas and mining sectors</h1>
        <h2 className="subtitle" dangerouslySetInnerHTML={{ __html: info.title }}></h2>
      </div>
    </div>

    <div className="row compare-graphs">
      <div className="column small-12 medium-small-11 medium-5 medium-small-offset-1 medium-offset-1 ">
        <p dangerouslySetInnerHTML={{ __html: info.description }}></p>
      </div>
      <div className="column small-12 medium-small-11 medium-5 medium-small-offset-1 compare-charts">
        <h2 className="subtitle">{info.country}: oil & gas vs. mining scores</h2>
        <div className="charts-items">
          {data.map((chart, i) => (
            <BarsCompare
              isComposite={i === 0}
              title={[sectors[info.sectors[1]], sectors[info.sectors[0]]]}
              key={i}
              id={`compare${i}`}
              data={chart}
            />
          ))}
        </div>
      </div>
    </div>
  </article>;
  return (
   window.innerWidth > 550 ? getLargerWidthScreen() : getSmallerWidthScreen()
  );
}

SectorsComparison.propTypes = {
  info: PropTypes.object,
  data: PropTypes.array
};

export default SectorsComparison;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/SectorsComparison.jsx